import {
  H2_TEAM_IMG01,
  H2_TEAM_IMG02,
  H2_TEAM_IMG03,
  H2_TEAM_IMG04,
  H3_TEAM_IMG01,
  H3_TEAM_IMG02,
  H3_TEAM_IMG03,
  H3_TEAM_IMG04,
  H4_TEAM_IMG01,
  H4_TEAM_IMG02,
  H4_TEAM_IMG03,
  H4_TEAM_IMG04,
  H5_TEAM_IMG01,
  H5_TEAM_IMG02,
  H5_TEAM_IMG03,
  H5_TEAM_IMG04,
  TEAM_IMG01,
  TEAM_IMG02,
  TEAM_IMG03,
  TEAM_IMG04,
} from "../lib/assets";

import sajal from "../assets/images/sajal.jpg";
import taufiq from "../assets/images/toufiq.jpg";
import srn from "../assets/images/srn.jpg";
import shrv from "../assets/images/shourav.jpg";
import bkrm from "../assets/images/bikrom.jpg";

export const TEAM_LIST_TWO = [
  {
    id: 1,
    href: "/team-details",
    src: H2_TEAM_IMG01,
    title: "Brooklyn Simmons",
    designation: "Finance Advisor",
  },
  {
    id: 2,
    href: "/team-details",
    src: H2_TEAM_IMG02,
    title: "Jenny Wilson",
    designation: "Finance Advisor",
  },
  {
    id: 3,
    href: "/team-details",
    src: H2_TEAM_IMG03,
    title: "Wade Warren",
    designation: "Finance Advisor",
  },
  {
    id: 4,
    href: "/team-details",
    src: H2_TEAM_IMG04,
    title: "Marvin McKinney",
    designation: "Finance Advisor",
  },
];

export const TEAM_LIST_THREE = [
  {
    id: 1,
    href: "/team-details",
    src: H3_TEAM_IMG01,
    title: "Brooklyn Simmons",
    designation: "Finance Advisor",
  },
  {
    id: 2,
    href: "/team-details",
    src: H3_TEAM_IMG02,
    title: "Jenny Wilson",
    designation: "Finance Advisor",
  },
  {
    id: 3,
    href: "/team-details",
    src: H3_TEAM_IMG03,
    title: "Wade Warren",
    designation: "Finance Advisor",
  },
  {
    id: 4,
    href: "/team-details",
    src: H3_TEAM_IMG04,
    title: "Marvin McKinney",
    designation: "Finance Advisor",
  },
];

export const TEAM_LIST_FOUR = [
  {
    id: 1,
    href: "/team-details",
    src: H4_TEAM_IMG01,
    title: "Brooklyn Simmons",
    designation: "Finance Advisor",
  },
  {
    id: 2,
    href: "/team-details",
    src: H4_TEAM_IMG02,
    title: "Jenny Wilson",
    designation: "Finance Advisor",
  },
  {
    id: 3,
    href: "/team-details",
    src: H4_TEAM_IMG03,
    title: "Wade Warren",
    designation: "Finance Advisor",
  },
  {
    id: 4,
    href: "/team-details",
    src: H4_TEAM_IMG04,
    title: "Marvin McKinney",
    designation: "Finance Advisor",
  },
];

export const TEAM_LIST_FIVE = [
  {
    id: 1,
    href: "/team-details",
    src: H5_TEAM_IMG01,
    title: "Brooklyn Simmons",
    designation: "Finance Advisor",
  },
  {
    id: 2,
    href: "/team-details",
    src: H5_TEAM_IMG02,
    title: "Jenny Wilson",
    designation: "Finance Advisor",
  },
  {
    id: 3,
    href: "/team-details",
    src: H5_TEAM_IMG03,
    title: "Wade Warren",
    designation: "Finance Advisor",
  },
  {
    id: 4,
    href: "/team-details",
    src: H5_TEAM_IMG04,
    title: "Marvin McKinney",
    designation: "Finance Advisor",
  },
];

export const TEAM_LIST_ONE = [
  {
    id: 1,
    href: "/team-details",
    src: sajal,
    title: "Sajal Saha",
    designation: "Founder & CEO",
    fbLink: "https://www.facebook.com/sajal.saha.july",
    lnLink: "https://www.linkedin.com/in/sajal-saha-93677113b/",
  },
  {
    id: 2,
    href: "/team-details",
    src: taufiq,
    title: "Toufiq Ul Aalam",
    designation: "Lead Operation",
    fbLink: "https://www.facebook.com/toufiqulalam89",
    lnLink: "https://www.linkedin.com/in/toufiqalam/",
  },
  {
    id: 3,
    href: "/team-details",
    src: bkrm,
    title: "Pronab Halder",
    designation: "CTO",
    fbLink: "https://www.facebook.com/vikramhalder103?mibextid=ZbWKwL",
    lnLink: "https://www.linkedin.com/in/vikramhalder?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },
  {
    id: 4,
    href: "/team-details",
    src: srn,
    title: "Eftekhar Soron",
    designation: "Creative Coder",
    fbLink: "https://www.facebook.com/iftekhar.jahan.soron.2024/",
    lnLink: "https://www.linkedin.com/in/iftekhar-jahan-soron-311626244/",
  },
  {
    id: 5,
    href: "/team-details",
    src: shrv,
    title: "Sourov Sarker",
    designation: "Creative coder",
    fbLink: "https://www.facebook.com/sourov82?mibextid=ZbWKwL",
    lnLink: "https://www.linkedin.com/in/vikramhalder?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },
];
